// extracted by mini-css-extract-plugin
module.exports = {"container":"ChapterNumber_container__M5GTF"};